<template>
    <div class="akitem" v-bind:id="site.site" v-if="doneFresh === true" :class="{blink: site.mode === 'collapse'}" :style="{width: itemWidth + 'px'}">
        <div class="mini" v-if="site.mode === 'mini'" v-on:mouseover=" unfoldItem = true" v-on:mouseout=" unfoldItem = false">
            <div class="holder">
            </div>
            <div class="source">
                <img v-bind:src="site.attrs.logo" :class="site.site">
            </div>
            <div class="holder">
                <img src="../assets/images/more-diluted.png" v-show="unfoldItem">
                <!--<span class="holder-hint" v-show="unfoldItem">点击展开</span>-->
            </div>
        </div>
        <div v-if="site.mode === 'collapse' && dataReady === true">
            <div class="i-header">
                <div class="i-site" v-if="site.dofresh === false">
                    <div class="logo-box" v-if="site.attrs.logo.length > 0 ">
                        <a :href="site.attrs.url" target="_blank" rel="nofollow"><img v-bind:src="site.attrs.logo" :class="site.site"></a>
                    </div>
                </div>
                <div class="i-refresh" v-else>
                    <div class="circle-box" @click="doReload">
                        <img class="circle" src="../assets/images/circle.png">
                        <div class="circle-hint">
                            点我更新
                        </div>
                    </div>
                </div>
                <div class="i-subs">
                    <div class="i-sub" v-bind:class="{'i-active': sindex === actSub}" v-for="(sub, sindex) in site['subs']" v-bind:key="sindex" @click="showSub(sindex)">
                        <span class="i-sub-title">{{sub['attrs']['cn']}}</span>
                    </div>
                </div>
            </div>
            <div class="i-content">
                <div class="singles">
                    <a :href="['/go/' + item.iid]" class="i-a" target="_blank" v-if="item.title !== 'nullItem'" v-for="(item, index) in actData.items" v-bind:key="index">
                        <div class="single">
                            <span class="seq" v-bind:class="{highlight: item.rank < 4 }">{{item.rank}}</span>
                            <span class="title">{{item.title}}<span class="new-tag" v-show="item.new_tag">新</span></span>
                            <span class="more" v-show="'more' in item">{{item.more}}</span>
                        </div>
                    </a>
                    <div class="single null" v-else>
                    </div>
                </div>
            </div>
            <div class="i-footer">
                <div class="i-mini" v-on:mouseover=" miniItem = true" v-on:mouseout=" miniItem = false">
                    <img class="i-mini-img" src="../assets/images/minimize-colored.png" @click="minizeItem" v-if="miniItem">
                    <img class="i-mini-img" src="../assets/images/minimize-diluted.png" @click="minizeItem" v-else>
                </div>
                <div class="i-hint">from <a :href="site.attrs.url" target="_blank" rel="nofollow">{{site.attrs.cn}}</a></div>
                <div class="i-op" v-bind:class="{'no-left': pageAttr[actSub]['curPage'] === 1, 'no-right': pageAttr[actSub]['curPage'] === pageAttr[actSub]['pageNum']}">
                    <div class="i-op-left" v-show="pageAttr[actSub]['curPage'] > 1" @click="prevPage()">
                        <div>
                            <img class="i-op-img" src="../assets/images/left-arrow.png">
                        </div>
                        <div>上一页</div>
                    </div>
                    <div class="i-op-right" v-show="pageAttr[actSub]['pageNum'] > 1 && pageAttr[actSub]['curPage'] < pageAttr[actSub]['pageNum'] " @click="nextPage()">
                        <div>下一页</div>
                        <div>
                            <img class="i-op-img" src="../assets/images/right-arrow.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
export default {
  props: ['site', 'pcindex', 'psindex', 'wclass'],
  name: "akitem",
  data () {
    return {
      // subs改为list，以实现按排序展示
      actSub: '',
      actData: {
        display: 10,
        itemNum: 0,
        items: []
      },
      pageAttr: {
      },
      //数据未加载好
      dataReady: false,
      doneFresh: true,
      unfoldItem: false,
      miniItem: false,
      itemWidth: 350,
    }
  },
  watch: {
    // 监测mode值的改变，由于mode值没有直接在代码中使用，它的改变不会使component rerender，使用watch实现
    site: function () {
      if(this.site.mode === 'mini'){
        this.itemMode = 'mini'
      }
    },
    wclass: function () {
      if(this.wclass === 'xsmall'){
        this.itemWidth = 310
      }
      else{
        this.itemWidth = 350
      }
    }
  },
  created(){
    this.setItemWidth()
    this.setSiteData()
  },
  updated:  function () {
    this.setSiteData()
  },
  methods: {
    setItemWidth: function () {
      if(this.wclass === 'xsmall'){
        this.itemWidth = 310
      }
      else{
        this.itemWidth = 350
      }
    },
    doReload: function (){
      this.dataReady = false
      var that = this
      this.$http.get('/sites/' + this.site.site, {}, function (r) {
        if (r.status === 0) {
          var _site = r.data.site
          _site.dofresh = false
          _site.inited = true
          _site.mode = 'collapse'
          // that.site = _site
          that.dataReady = false //重新渲染数据
          that.doneFresh = false //重新渲染数据
          // TODO actData display = single？？？
          that.actData = {
            display: 'single',
            itemNum: 0,
            items: []
          }
          that.pageAttr = {

          }
          that.$emit("reloadPcSite", that.pcindex, that.psindex, _site);
        }
      })
    },
    minizeItem: function (event){
      this.$emit("miniPcSite", this.pcindex, this.psindex);
      this.miniItem = false
      event.stopPropagation();
    },
    setSiteData: function (){
      // 确保仅在加载数据后进行更新，否则会导致每次数据有修改时比如下一页...数据被重新加载
      if(this.site.mode === 'collapse' && this.dataReady === false){
        var _subs = this.site.subs
        // 刷新数据重置actSub
        this.actSub = ''
        for(var skey in _subs){
          // 默认显示第一个sub
          var _pageNum = 1;
          if(this.actSub === '') {
            // 通过这样for循环获取的skey为字符串
            this.actSub = parseInt(skey)
          }
          _pageNum = Math.ceil(_subs[skey]['items'].length / _subs[skey]['attrs']['display'])
          this.pageAttr[skey] = {
            pageNum:_pageNum,
            curPage: 1
          }
          for(var i = 0; i < _subs[skey]['items'].length; i++){
            _subs[skey]['items'][i]['rank'] = i + 1
            // 判断网站，如果网站为好奇心日报，截断标题，最长显示55个字
            if(this.site.site === 'qdaily'){
              if(_subs[skey]['items'][i].title.length > 58){
                _subs[skey]['items'][i].title = _subs[skey]['items'][i].title.substr(0, 55) + '...'
              }
            }
          }
          this.site.subs = _subs
          if(this.actData.items.length === 0){
            this.actData = {
              display: _subs[skey]['attrs']['display'],
              items: _subs[skey]['items'].slice(0, _subs[skey]['attrs']['display'])
            }
          }
          //填充空白item数据便于排版使用
          var _nullNum = 0
          if(_subs[skey]['items'].length % _subs[skey]['attrs']['display'] !== 0){
            _nullNum = _subs[skey]['attrs']['display'] - _subs[skey]['items'].length % _subs[skey]['attrs']['display']
          }
          var j = 0
          while(j < _nullNum){
            _subs[skey]['items'].push({title: 'nullItem', seq: -1})
            j++
          }
        }
        this.dataReady = true
        this.doneFresh = true
      }
    },
    showSub: function (sub) {
      this.actSub = sub
      var _itemNum = this.site['subs'][this.actSub]['attrs']['display']
      var _start = _itemNum * (this.pageAttr[this.actSub].curPage - 1)
      this.actData = {
        display: this.site['subs'][this.actSub]['attrs']['display'],
        items: this.site.subs[this.actSub]['items'].slice(_start , _start + _itemNum)
      }
    },
    nextPage: function () {
      // this.pageAttr[this.actSub].curPage = this.pageAttr[this.actSub].curPage + 1
      Vue.set(this.pageAttr[this.actSub], 'curPage', this.pageAttr[this.actSub].curPage + 1)
      var _itemNum = this.site['subs'][this.actSub]['attrs']['display']
      var _start = _itemNum * (this.pageAttr[this.actSub].curPage - 1)
      this.actData = {
        display: this.site['subs'][this.actSub]['attrs']['display'],
        items: this.site['subs'][this.actSub]['items'].slice(_start , _start + _itemNum)
      }
    },
    prevPage: function () {
      // this.pageAttr[this.actSub].curPage = this.pageAttr[this.actSub].curPage - 1
      Vue.set(this.pageAttr[this.actSub], 'curPage', this.pageAttr[this.actSub].curPage - 1)
      var _itemNum = this.site['subs'][this.actSub]['attrs']['display']
      var _start = _itemNum * (this.pageAttr[this.actSub].curPage - 1)
      this.actData = {
        display: this.site['subs'][this.actSub]['attrs']['display'],
        items: this.site.subs[this.actSub]['items'].slice(_start , _start + _itemNum)
      }
    }
  }
}
</script>

<style lang="less">
    .akitem{
        width: 350px;
        /*height: 450px;*/
        background-color: #FFFFFF;
        border-radius: 5px;
        padding: 0 10px;
        @-o-keyframes fadeIt {
            0%   { background-color: #FFFFFF; }
            50%  { background-color: #BADEF1; }
            100% { background-color: #FFFFFF; }
        }
        @keyframes fadeIt {
            0%   { background-color: #FFFFFF; }
            50%  { background-color: #BADEF1; }
            100% { background-color: #FFFFFF; }
        }
        &.blink{
            background-image:none !important;
            -o-animation: fadeIt 1s ease-in-out;
            animation: fadeIt 1s ease-in-out;
        }
        .mini{
            padding: 10px 0;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .holder{
                width: 30px;
                .holder-hint{
                    color: #999999;
                    font-size: 0.7rem;
                }
                img{
                    height: 20px;
                }
            }
            .source{
                flex: 1;
                text-align: center;
                img{
                    height: 30px;
                    &.zhihu{
                        /*height: 25px;*/
                    }
                    &.cbo{
                        /*height: 25px;*/
                    }
                }
            }
        }
        .i-header{
            display: flex;
            align-items: flex-end;
            justify-content: left;
            padding: 10px 0;
            border-bottom: 1px solid #f8f8f8;
            height: 50px;
            .i-site{
                flex: 1;
                font-size: 1.2rem;
                font-weight: bold;
                .logo-box{
                    height: 25px;
                    img{
                        height: 25px;
                        &.zhihu{
                            height: 20px;
                        }
                        &.cbo{
                            height: 20px;
                        }
                    }
                }
            }
            .i-refresh{
                flex: 1;
                .circle-box{
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    cursor: pointer;
                    .circle{
                        width: 15px;
                    }
                    .circle-hint{
                        margin-left: 5px;
                        font-size: 0.9rem;
                        color: #333333;
                    }
                }
            }
            .i-subs{
                display: flex;
                align-items: flex-end;
                justify-content: left;
                /*padding: 0 10px;*/
                .i-sub{
                    font-size: 0.9rem;
                    position: relative;
                    margin-left: 20px;
                    cursor: pointer;
                    &.i-active{
                        font-weight: bold;
                        &:after{
                            content: "";
                            position: absolute;
                            display: block;
                            width: 100%;
                            border-bottom: 2px solid #3DB4F1;
                            left: 0;
                            bottom: -11px;
                            background-color: #D23023;
                        }
                    }
                }
            }
        }
        .i-content{
            padding: 6px 0;
            /*position: relative;*/
            /*overflow-y: scroll;*/
            height: 320px;
            .singles{
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                height: 320px;
                max-height: 100%;

                a:visited {
                    .single{
                        .title{
                            color: #999999;
                        }
                    }
                }
                .single{
                    display: flex;
                    align-items: center;
                    justify-content: left;
                    font-size: 0.85rem;
                    /*padding-bottom: 12px;*/
                    &:hover{
                        /*background-color: #BADEF1;*/
                        /*padding: 15px 5px;*/
                        .seq{
                            color: #3DB4F1;
                        }
                        .title{
                            color: #3DB4F1;
                        }
                        .more{
                            color: #3DB4F1;
                        }
                    }
                    .seq{
                        color: #E2E2E2;
                        font-style: italic;
                        width: 25px;
                        &.highlight{
                            color: #3DB4F1;
                        }
                    }
                    .title{
                        flex: 1;
                        color: #333333;
                        .new-tag{
                            background-color: #3DB4F1;
                            font-size: 10px;
                            color: #FFFFFF;
                            padding: 0px 2px;
                            margin-left: 5px;
                        }
                    }
                    .more{
                        color: #999999;
                        font-size: 0.8rem;
                    }
                    &.null{
                        &:hover{
                            background-color: #FFFFFF;
                            padding: 0;
                        }
                        height: 25px;
                    }
                }
            }
        }
        .i-footer{
            border-top:1px solid #f8f8f8;
            display: flex;
            flex-direction: row;
            padding: 10px 0;
            .i-mini{
                width: 14px;
                margin-right: 8px;
                cursor: pointer;
                .i-mini-img{
                    width: 14px;
                    display: block;
                }
            }
            .i-hint{
                color: #999999;
                font-size: 0.7rem;
                flex: 1;
            }
            .i-op{
                display: block;
                /*flex-direction: row;*/
                /*align-items: center;*/
                color: #666666;
                width: 120px;
                /*justify-content: flex-end;*/
                /*&.no-left{*/
                    /*justify-content: flex-end;*/
                /*}*/
                /*&.no-right{*/
                    /*justify-content: flex-start;*/
                /*}*/
                .i-op-img{
                    width: 10px;
                    display: block;
                }
                .i-op-left,.i-op-right{
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .i-op-left{
                    width: 50%;
                    float: left;
                    justify-content: left;
                    .i-op-img{
                        margin-right:3px;
                    }
                }
                .i-op-right{
                    width: 50%;
                    float: right;
                    justify-content: flex-end;
                    .i-op-img{
                        margin-left:3px;
                    }
                }
                /*.i-op-right{*/
                    /*margin-left: 30px;*/
                /*}*/
            }
        }
    }

</style>